import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { TextChunkSchema } from './text-chunks';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const TextChunkBoundingBoxSchema = z.object({
  textChunkBoundingBoxId: PrimaryKeySchema,
  textChunkId: TextChunkSchema.shape.textChunkId,
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
  pageNumber: z.number(),
  createdAt: z.coerce.date(),
});

export type TextChunkBoundingBox = z.infer<typeof TextChunkBoundingBoxSchema>;

export const TextChunkBoundingBoxesSchema = z.array(TextChunkBoundingBoxSchema);

export type TextChunkBoundingBoxes = z.infer<
  typeof TextChunkBoundingBoxesSchema
>;

export const TextChunkBoundingBoxesQuerySchema = z
  .object({
    textChunkBoundingBoxIds: commaDelimitedList(
      TextChunkBoundingBoxSchema.shape.textChunkBoundingBoxId.array(),
    ).optional(),
    textChunkIds: commaDelimitedList(
      TextChunkSchema.shape.textChunkId.array(),
    ).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type TextChunkBoundingBoxesQuery = z.infer<
  typeof TextChunkBoundingBoxesQuerySchema
>;
